"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAuthData = void 0;
const generated_1 = require("../../graphql/generated");
const setAuthData = (context, event) => (callback) => {
    try {
        const snapAuthUpdatedEvent = new CustomEvent("SNAP_AUTH_UPDATED", { detail: "setAuthData" });
        window.dispatchEvent(snapAuthUpdatedEvent);
        if (!context.apolloClient) {
            throw new Error("No apollo client in context");
        }
        if (!event || event.type !== "authLoadingSuccessEvent") {
            throw new Error("No valid event for setting auth data");
        }
        context.apolloClient.writeQuery({ query: generated_1.IsApiReadyDocument, data: { apiReady: true } });
        callback({ type: 'dataSavedEvent' });
    }
    catch (e) {
        console.error(e);
        callback({ type: 'authFailedEvent' });
    }
};
exports.setAuthData = setAuthData;
